export const PRODUCT_EDITOR_TABS = [
  { key: "TabOne", labelKey: "product.basicInfo" },
  { key: "TabTwo", labelKey: "product.warehousePricing" },
  { key: "TabThree", labelKey: "product.productLinks" },
  { key: "TabFour", labelKey: "product.seo" },
  { key: "TabFive", labelKey: "product.productImages" },
];

export const getProductTypeOptions = (t) => [
  { label: t("product.sales"), value: "Sales" },
  { label: t("product.purchases"), value: "Purchases" },
  {
    label: t("product.salesAndPurchases"),
    value: "SalesAndPurchases",
  },
];

export const PRODUCT_FORM_PANEL_CLASS =
  "rounded-2xl border border-slate-200 bg-slate-50/70 p-3 shadow-sm md:p-4";

export const PRODUCT_TAB_WRAPPER_CLASS =
  "mb-4 flex flex-wrap gap-2 rounded-2xl border border-slate-200 bg-white p-2 shadow-sm";

export const getProductTabClassName = (isActive) =>
  `flex-1 min-w-[140px] rounded-xl border text-center cursor-pointer px-4 py-2.5 text-sm font-medium transition-all duration-200 ${
    isActive
      ? "border-[#251658] bg-[#251658] text-white shadow-sm"
      : "border-transparent bg-slate-50 text-slate-600 hover:border-[#251658]/15 hover:bg-[#251658]/5 hover:text-[#251658]"
  }`;

export const PRODUCT_OPTION_ROW_CLASS =
  "flex items-center justify-between gap-4 rounded-xl border border-slate-200 bg-white px-4 py-3";

export const PRODUCT_OPTION_LABEL_CLASS = "text-xs font-medium text-[#251658]";

export const PRODUCT_FORM_SECTION_CLASS =
  "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm";

export const normalizeApiCollection = (payload) => {
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const normalizeApiItem = (payload) => {
  if (Array.isArray(payload?.data)) return payload.data[0] || null;
  if (payload?.data && !Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload)) return payload[0] || null;
  return payload || null;
};

export const getBooleanBadgeClassName = (isActive) =>
  isActive
    ? "bg-[#eef6e4] text-[#699635]"
    : "bg-slate-200 text-slate-600";
